// import { configureStore } from '@reduxjs/toolkit'
// import LoginReducer from './LoginReducer';
// import LoadingReducer from './loadingReducer';
// import AuthenticationReducer from './AuthenticationReducer';

// export default configureStore({
//     reducer: {
//         login: LoginReducer,
//         loading: LoadingReducer,
//         Authentication: AuthenticationReducer
//     },
// })


// store.js
// import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
// import loginReducer from './LoginReducer';
// import loadingReducer from './loadingReducer';
// import authenticationReducer from './AuthenticationReducer';
// import { persistReducer, persistStore } from 'redux-persist';
// import AsyncStorage from '@react-native-async-storage/async-storage';

// const store = configureStore({
//     reducer: {
//         login: loginReducer,
//         loading: loadingReducer,
//         authentication: authenticationReducer,
//     }
// });


// export { store };
// const persistConfig = {
//     key: 'root',
//     storage: AsyncStorage,

// };

// const persistedReducer = persistReducer(persistConfig, {
//     login: loginReducer,
//     loading: loadingReducer,
//     authentication: authenticationReducer,
// });
// export const store = configureStore({
//     reducer: persistedReducer,
// });
// export const persistor = persistStore(store);


// store.js

// import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import loginReducer from './LoginReducer';
// import loadingReducer from './loadingReducer';
// import authenticationReducer from './AuthenticationReducer';
// import { persistReducer, persistStore } from 'redux-persist';
// import AsyncStorage from '@react-native-async-storage/async-storage';

// const persistConfig = {
//     key: 'root',
//     storage: AsyncStorage,
// };

// const rootReducer = combineReducers({
//     login: loginReducer,
//     loading: loadingReducer,
//     authentication: authenticationReducer,
// })

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//     reducer: persistedReducer,
// });


import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import {
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import LoginReducer from './LoginReducer';
import AuthenticationReducer from './AuthenticationReducer';
import loadingReducer from './loadingReducer';
import { configureStore } from '@reduxjs/toolkit';
import MailSentReducer from './MailSentReducer';
import PendingReducer from './PendingReducer';
import AcceptedReducer from './AcceptedReducer';
import FilterReducer from './FilterReducer';
import V2PRMReducer from './V2PRMReducer';
import KYCRequestReducer from './KYCRequestReducer';
import CustomerAuthentication from './CustomerAuthentication';
import CustomerDataReducer from './CustomerDataReducer';
import DetailsReducer from './DetailsReducer';
import StepsReducer from './StepsReducer';
import SuccessReducer from './SuccessReducer';
import CustomerBankDetailsReducer  from './CustomerBankDataReducer';


const persistConfig = {
    key: 'onboarding',
    storage,
};
const reducers = combineReducers({
    login: LoginReducer,
    authentication: AuthenticationReducer,
    loading: loadingReducer,
    mailSent: MailSentReducer,
    pending: PendingReducer,
    accepted: AcceptedReducer,
    filterData: FilterReducer,
    v2pRMData: V2PRMReducer,
    kycRequestData: KYCRequestReducer,
    customerAuthenticate: CustomerAuthentication,
    customerData: CustomerDataReducer,
    details: DetailsReducer,
    stepsData: StepsReducer,
    successPage: SuccessReducer,
    customerBankDetails:CustomerBankDetailsReducer
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

